import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ReactPaginate from "react-paginate";
import * as XLSX from "xlsx";
import DatePicker from "react-multi-date-picker";
import { apiRequest } from "../../apiServices/allApi";

const $ = require("jquery");
$.Datatable = require("datatables.net");

const PenaltyReport = () => {
  const [user, setUser] = useState();
  const id = localStorage.getItem("id");

  const searchHandler = (event) => {
    let key = event.target.value;
    setSearchList(key);
  };

  //user for searching..
  const [searchList, setSearchList] = useState(0);
  const [searchType, setSearchType] = useState("Phone");

  //use for pagination..
  let [limit, setLimit] = useState(20);

  const setpageLimit = (event) => {
    let key = event.target.value;
    setLimit(key);
  };
  const [pageNumber, setPageNumber] = useState(0);
  const [numberOfPages, setNumberOfPages] = useState(0);
  const Year = new Date().getFullYear();
  const Month = new Date().getMonth() + 1; // Adding 1 to the month since getMonth() returns 0-11

  const formattedMonth = Month < 10 ? `0${Month}` : `${Month}`;

  const dynamicStartDate = `${Year}/${formattedMonth}/01`;
  const dynamicEndDate = `${Year}/${formattedMonth}/31`;

  const [startDate, setStartDate] = useState(dynamicStartDate);
  const [endDate, setEndDate] = useState(dynamicEndDate);

  const handleStartDateChange = (date) => {
    setStartDate(date);
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
  };

  //react paginate..
  const handlePageClick = async (data) => {
    let currentPage = data.selected + 1;
    setPageNumber(currentPage);
    // scroll to the top
  };

  const profle = async () => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(
        `admin/get_txn/penaltyreports/all?page=${pageNumber}&_limit=${limit}&_q=${searchList}&_stype=${searchType}&FROM_DATE=${startDate}&TO_DATE=${endDate}`,
        "GET",
        null,
        headers,
      );
      setUser(res.data.datefind);
      setNumberOfPages(res.data.totalPages);
    } catch (error) {
    } finally {
    }
  };

  const dateFormat = (e) => {
    const date = new Date(e);
    const newDate = date.toLocaleString("default", {
      year: "numeric",
      month: "numeric",
      day: "numeric",
    });
    return newDate;
  };

  useEffect(() => {
    profle();
  }, [pageNumber, limit, startDate, endDate, searchList, searchType]);

  if (user === undefined) {
    return null;
  }

  const createDownloadData = () => {
    handleExport();
  };
  const handleExport = () => {
    let table1 = [
      {
        A: "Id",
        B: "UserName",
        C: "PhoneNumber",
        D: "Penalty Amount",
        E: "Penalty By",
        // F:"Penalty by (ID)"
      },
    ];

    user.forEach((row) => {
      const userDetails = row;
      table1.push({
        A: userDetails._id,
        B: userDetails.User_id ? userDetails.User_id.Name : "",
        C: userDetails.User_id ? userDetails.User_id.Phone : "",
        D: userDetails.amount,
        E: userDetails.action_by ? userDetails.action_by.Name : "N/A",
        // F:(userDetails.action_by)?userDetails.action_by:'N/A'
      });
    });

    //table1 = [{A:"User Details"}].concat(table1);
    /* convert state to workbook */
    const ws = XLSX.utils.json_to_sheet(table1, {
      skipHeader: true,
    });
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
    /* generate XLSX file and send to client */
    XLSX.writeFile(wb, "PenaltyReports.xlsx");
  };
  return (
    <>
      {/* <h4 className='font-weight-bold my-3'>ALL CHALLANGES</h4> */}
      <div className="row mt-5">
        <div className="col-12 grid-margin">
          <div className="card">
            <div className="card-body p-4">
              <div className="d-flex flex-wrap justify-content-between align-items-center mb-3">
                <h4 className="dashboard_heading m-0 text-danger">
                  <i className="mdi mdi-alert-octagon text-danger mr-2"></i>{" "}
                  Penalty Reports
                </h4>
                <button
                  onClick={() => {
                    createDownloadData();
                  }}
                  className="btn btn-primary btn-sm"
                  style={{ whiteSpace: "nowrap" }}
                >
                  <i className="mdi mdi-download mr-1"></i> Export Data
                </button>
              </div>

              <div className="admin-filter-bar">
                <select
                  className="form-control"
                  style={{ maxWidth: "170px" }}
                  id="searchType"
                  name="searchtype"
                  value={searchType}
                  onChange={(e) => setSearchType(e.target.value)}
                >
                  <option value="Phone">Search by Phone</option>
                  <option value="_id">Search by User Id</option>
                </select>

                <input
                  type="text"
                  placeholder="Search..."
                  className="form-control"
                  style={{ flex: "1", minWidth: "150px" }}
                  onChange={searchHandler}
                />

                <DatePicker
                  selected={startDate}
                  value={startDate}
                  onChange={handleStartDateChange}
                  selectsStart
                  startDate={startDate}
                  endDate={endDate}
                  placeholderText="Start Date"
                  className="form-control"
                />
                <span className="admin-filter-separator">to</span>
                <DatePicker
                  selected={endDate}
                  onChange={handleEndDateChange}
                  value={endDate}
                  selectsEnd
                  startDate={startDate}
                  endDate={endDate}
                  placeholderText="End Date"
                  minDate={startDate}
                  className="form-control"
                />

                <select
                  className="form-control"
                  
                  id="pagelimit"
                  name="pagelimit"
                  value={limit}
                  onChange={setpageLimit}
                >
                  <option value="10">10 / page</option>
                  <option value="20">20 / page</option>
                  <option value="50">50 / page</option>
                  <option value="100">100 / page</option>
                  <option value="500">500 / page</option>
                </select>
              </div>
              <div className="table-responsive">
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th>#</th>
                      {id == "67f8f9731bb8e80965dd62b8" ? <th> ID</th> : ""}
                      <th> Phone</th>
                      <th> User</th>
                      <th> Amount </th>
                      <th> Reason </th>
                      <th> Status </th>
                      <th> Date </th>
                      <th>Penalty by</th>
                      {/* <th>Penalty by Id</th> */}
                    </tr>
                  </thead>

                  <tbody>
                    {user &&
                      user.map((data, key) => (
                        <tr>
                          <td>{key + 1}</td>
                          {id == "67f8f9731bb8e80965dd62b8" ? (
                            <td>{data._id}</td>
                          ) : (
                            ""
                          )}
                          <td>
                            {localStorage.getItem("user") === "Admin" ||
                            localStorage.getItem("updateLegalData") ===
                              "true" ? (
                              <span className="pl-2">
                                {data.User_id ? data.User_id.Phone : ""}
                              </span>
                            ) : (
                              <span className="pl-2">{`${
                                "********" +
                                data.User_id.Phone.toString().slice(-2)
                              }`}</span>
                            )}
                          </td>
                          <td>
                            {data.User_id && (
                              <Link
                                className="btn btn-sm btn-outline-info"
                                to={`/user/view_user/${data.User_id._id}`}
                              >
                                {data.User_id.Name}
                              </Link>
                            )}
                          </td>

                          <td>{data.amount}</td>
                          <td>{data.txn_msg}</td>
                          <td className="font-weight-bold text-success">
                            {data.status}
                          </td>
                          <td>{dateFormat(data.createdAt).split(",")[0]} </td>
                          <td>
                            {data.action_by ? data.action_by.Name : "N/A"}
                          </td>
                          {/* <td>{(data.action_by)?data.action_by:'N/A'}</td> */}
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>

              <div className="mt-4">
                <ReactPaginate
                  previousLabel={"Previous"}
                  nextLabel={"Next"}
                  breakLabel={"..."}
                  pageCount={numberOfPages}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={3}
                  onPageChange={handlePageClick}
                  containerClassName={"pagination justify-content-center"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                  previousClassName={"page-item"}
                  previousLinkClassName={"page-link"}
                  nextClassName={"page-item"}
                  nextLinkClassName={"page-link"}
                  breakClassName={"page-item"}
                  breakLinkClassName={"page-link"}
                  activeClassName={"active"}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PenaltyReport;
